import { createFileRoute } from '@tanstack/react-router'

import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('cd-angel')!

export const Route = createFileRoute('/cd-angel')({
  loader: () => loadBrandCampaign(campaign),
  head: () => brandCampaignHead(campaign),
  component: CdAngelPage,
})

function CdAngelPage() {
  return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} />
}
